import LoginPage from "beaktShared/views/GenericPages/LoginPage.js";
import Home from "beaktAdmin/views/Home.js";
import FranquiaList from "beaktAdmin/views/Cadastros/FranquiaList.js";
import Gateway from "./views/Cadastros/Gateway";

// @material-ui/icons
import HomeIcon from "@material-ui/icons/Home";
import Settings from "@material-ui/icons/Settings";
import ConnectWithoutContact from "@material-ui/icons/LeakAdd";

var Routes = [
  {
    path: "/login",
    name: "login",
    mini: "L",
    component: LoginPage,
    layout: "/auth",
    showmenu: false
  },
  {
    path: "/home",
    name: "home",
    mini: "H",
    icon: HomeIcon,
    component: Home,
    layout: "/admin",
    showmenu: true
  },  
  {
    path: "/franquia",
    name: "franchise",
    mini: "F",
    icon: Settings,
    component: FranquiaList,
    layout: "/admin",
    showmenu: true
  }, 
  {
    path: "/gateway",
    name: "gateway",
    mini: "G",
    icon: ConnectWithoutContact,
    component: Gateway,
    layout: "/admin",
    showmenu: true
  }, 
];
export default Routes;
